import React, {
  ChangeEvent, useEffect, useState,
} from 'react';
import { useFormContext, UseFormRegisterReturn } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getQuote } from '../../../features/quote/QuoteSlice';
import {
  ErnNumberInterface, Field,
} from '../../../types';
import Tooltip from '../Tooltip';

export interface ErnNumberProps {
    field: Field;
    error?: string;
    inputRef: UseFormRegisterReturn;
    onChange: (value: ErnNumberInterface) => void
}

function ErnNumberInput(props: ErnNumberProps) {
  const {
    field, error, inputRef, onChange,
  } = props;
  const {
    data,
  } = useSelector(getQuote);
  const { setValue } = useFormContext();
  const [ernNumber, setErnNumber] = useState<ErnNumberInterface>({});
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setErnNumber({
      ...ernNumber,
      [e.currentTarget.name]: e.currentTarget.value,
    });
    onChange({
      ...ernNumber,
      [e.currentTarget.name]: e.currentTarget.value,
    });
  };

  useEffect(() => {
    setErnNumber(data[field.formId] || field.value || {});
    setValue(inputRef.name, data[field.formId] || field.value || '');
  }, []);

  return (
    <div className={`mb-4 form-card p-4 ${error ? 'error' : ''}`}>
      <label htmlFor={field.id} className="form-label my-2">
        {field.label}
        {field.required
                && <span className="ms-2 d-inline-block asterix">*</span>}
      </label>

      <div className="input-group mb-3">
        <input
          type="text"
          onChange={handleOnChange}
          id={field.field_areacode}
          name={field.field_areacode}
          className="col-4 p-3"
          placeholder="Area Code"
          aria-label="Area Code"
          value={ernNumber[field.field_areacode || ''] || ''}
        />
        <input
          type="text"
          onChange={handleOnChange}
          id={field.field_serial_number}
          name={field.field_serial_number}
          className="col-8 p-3"
          placeholder="Serial Number"
          aria-label="Serial Code"
          value={ernNumber[field.field_serial_number || ''] || ''}
        />
      </div>

      <div className="form-card-footer d-flex justify-content-between">
        {
                    error
                    && <small className="error" dangerouslySetInnerHTML={{ __html: error }} />
                }
        {field.tooltip && <Tooltip tooltipText={field.tooltip} />}
      </div>
    </div>
  );
}
ErnNumberInput.defaultProps = {
  error: false,
};

export default ErnNumberInput;
